import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
export default {
    methods: {
        handleAxiosException: function(exception) {
            var errors = [];
            if (exception.response && (exception.response.status == 400) && exception.response.data && exception.response.data.errors) {
                for (var i in exception.response.data.errors) {
                    exception.response.data.errors[i].forEach(error => errors.push(error));
                }
            } else if (exception.response && (exception.response.status == 400) && exception.response.data && exception.response.data.Message) {
                errors.push(exception.response.data.Message);
            } else if (exception.response && (exception.response.status == 400) && exception.response.data) {
                errors.push(exception.response.data);
            } else if (exception.response && (exception.response.status == 401) && exception.response.data) {
                errors.push(exception.response.data);
            } else if (exception.response && (exception.response.status == 403) && exception.response.data) {
                errors.push(exception.response.data);
            } else if (exception.response && (exception.response.status == 404) && exception.response.data) {
                errors.push(exception.response.data);
            } else if (exception.response && (exception.response.status == 409) && exception.response.data) {
                errors.push(exception.response.data);
            } else if (exception.response && (exception.response.status == 500) && exception.response.statusText) {
                errors.push(exception.response.statusText);
            } else if (exception.message) {
                errors.push(exception.message);
            }
            return errors;
        },
        showErrorsToast: function(errors, title = null, autoHide = true) {
            if (title == null) title = 'Error';
            var toastContent = [];
            this.$bvToast.hide(); // hides previous toast
            
            errors.forEach(error => {
                toastContent.push(
                    this.$createElement(
                        'p',
                        error
                    )
                );
            });

            this.$bvToast.toast([toastContent], {
                title: title,
                variant: 'danger',
                appendToast: true,
                noAutoHide: !autoHide
            });
        }
    }
}